import { Component, ElementRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ConversationGroup, ConversationRow } from "../../../services/conversation-store.service";
import { AgentKey } from "../../../model/uchat.model";
import { AgentCatalogueService } from "src/app/services/agent-catalogue.service";
import { MenuToggle } from "src/app/model/menuToggle";



@Component({
    selector: 'app-conversation-sidebar',
    standalone: true,
    imports: [
        FormsModule
    ],
    templateUrl: './conversation-sidebar.component.html',
    styleUrl: './conversation-sidebar.component.scss',
    host: {
        "(document:click)": "onDocumentClick($event)"
    }
})
export class ConversationSidebarComponent implements OnChanges {

    constructor(
        private agentCatalogueService:AgentCatalogueService
    ){
        
    }

    @Input() public groupedRows: ConversationGroup[] = [];
    @Input() public activeId: string | null = null;
    @Input() public query: string = "";
    @Input() public listError: boolean = false;
    @Input() public openMenu: string | null = null;
    @Input() public pendingDeleteId: string | null = null;
    @Input() public renamingId: string | null = null;
    @Input() public renameText: string = "";

    @Output() public menuDismissed = new EventEmitter<void>();

    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly menu = viewChild<ElementRef<HTMLElement>>("menu");

    // ngModel mirror of "query", for the search box.
    public queryValue: string = "";

    //ngModel mirror of "renameText", for the rename input.
    public renameValue: string = "";

    /**
     * Pull a changed input down into its mirror.
     * @param changes 
     */
    public ngOnChanges( changes: SimpleChanges ): void {
        if ( changes["query"] !== undefined && this.query !== this.queryValue ) {
            this.queryValue = this.query;
        }
        if ( changes["renameText"] !== undefined && this.renameText !== this.renameValue ) {
            this.renameValue = this.renameText;
        }
    }

    @Output() public newChatRequested: EventEmitter<void> = new EventEmitter<void>();
    @Output() public retryRequested: EventEmitter<void> = new EventEmitter<void>();
    /** Named "<input>Change" so the parent may use "[(query)]" if it prefers. */
    @Output() public queryChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() public renameTextChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() public conversationOpened: EventEmitter<string> = new EventEmitter<string>();
    @Output() public menuToggled: EventEmitter<MenuToggle> = new EventEmitter<MenuToggle>();
    @Output() public renameStarted: EventEmitter<ConversationRow> = new EventEmitter<ConversationRow>();
    @Output() public renameCommitted: EventEmitter<void> = new EventEmitter<void>();
    @Output() public renameCancelled: EventEmitter<void> = new EventEmitter<void>();
    @Output() public deleteRequested: EventEmitter<ConversationRow> = new EventEmitter<ConversationRow>();
    @Output() public deleteConfirmed: EventEmitter<ConversationRow> = new EventEmitter<ConversationRow>();
    @Output() public openInNewChatRequested: EventEmitter<ConversationRow> = new EventEmitter<ConversationRow>();

    /**
     * Gets the agent based on the key provided.
     * 
     * @param key 
     * @returns 
     */
    public agentLabelFor(key: AgentKey): string {
        return this.agentCatalogueService.agentLabel(key);
    }

    /**
     * Checks for clicks and dismisses any open kebabs if
     * click is not on kebab
     * @param event 
     * @returns 
     */
    public onDocumentClick(event: MouseEvent): void {
        let menu = this.menu()?.nativeElement;
        if (this.openMenu === null || menu == null) {
            return;
        }
        let path = event.composedPath();
        let onKebab = path.some(node =>
            node instanceof HTMLElement && node.classList.contains("kebab")
            && this.host.nativeElement.contains(node)
        );
        if (!path.includes(menu) && !onKebab) {
            this.menuDismissed.emit();
        }
    }
}
